"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.data = [
    {
        companyName: 'Trunkrs B.V.',
        emailAddress: 'hidde@trunkrs.nl',
        id: 1,
        locationId: 1,
        name: 'Hidde Stokvis',
        phoneNumber: '+31639751448',
    },
];
